// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { useEffect, useState } from "react";
import * as CognitoGroupService from "../../services/cognitoGroup";
import * as AccountService from '../../services/accounts'

import {
  Button,
  Icon,
  Container,
  Form,
  Dimmer,
  Loader,
  List,
  Grid
} from "semantic-ui-react";
import { fragments } from 'services/get-fragments'

export default (p) => {
  const { setModalFormOpen, id } = p;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [accounts, setAccounts] = useState([])
  const [reload, setReload] = useState(false)

  const excludeFromGroup = (username) => {
    CognitoGroupService.AdminRemoveUserFromGroup(id.GroupName, username).finally(
      setReload(!reload)
    )
  };

  const addToGroup = (username) => {
    CognitoGroupService.AdminAddUserToGroup({ GroupName: id.GroupName, Username: username }).finally(
      setReload(!reload)
    )
  };

  // Initial load
  useEffect(() => {
    var usersInGroups = []
    CognitoGroupService.AdminGet(p.id.GroupName)
      .then((out) => {
        usersInGroups = out.Users
        setUsers(out.Users);
      })
      .catch((e) => { console.log("No Users", e) })
      .finally(() => {
        AccountService.fetchRegisteredAccounts().then((accounts) => {
          //Elimina Usuarios que ya estan en el grupo de la lista de Registrados
          for (let i = 0; i < usersInGroups.length; i++) {
            for (let j = 0; j < accounts.length; j++) {
              if (usersInGroups[i].Username === accounts[j].UserId) {
                accounts.splice(j, 1)
                j--
              }
            }
          }
          setAccounts(accounts)
          setLoading(false)
        }).catch((e) => { console.log("No Accounts", e) })
      });
    // eslint-disable-next-line
  }, [loading]);

  return (
    <Container style={{ padding: "1em" }}>
      <Dimmer active={loading} inverted>
        <Loader />
      </Dimmer>
      <Form>
        <p>
          <b>{fragments.cognitoGroup.groupName}: </b>
        </p>
        <Form.Field>
          {id.GroupName}
        </Form.Field>
        <Grid columns={2}>
          <Grid.Column>
            <b>{fragments.cognitoGroup.users_in_group}: </b><hr />
            <List divided relaxed>
              {users.map((option) => (
                <List.Item key={option.Username}>
                  <List.Icon name='user circle' size='large' verticalAlign='middle' />
                  <List.Content>
                    <List.Header as='a'>{option.Attributes[1].Value}</List.Header>
                    <List.Description as='a'>{option.UserStatus}
                      <Button size="small" style={{ float: 'right' }} icon="chevron right" onClick={() => { setLoading(true); excludeFromGroup(option.Username) }} />
                    </List.Description>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          </Grid.Column>
          <Grid.Column>
            <b>{fragments.cognitoGroup.registered_users}</b><hr />
            <List divided relaxed>
              {accounts.map((option) => (
                <List.Item key={option.UserId}>
                  <List.Icon name='user circle' size='large' verticalAlign='middle' />
                  <List.Content>
                    <List.Header as='a'>{option.EmailAddress}</List.Header>
                    <List.Description as='a'>{option.registrationStatus}
                      <Button size="small" style={{ float: 'right' }} icon="chevron left" onClick={() => { setLoading(true); addToGroup(option.UserId) }} />
                    </List.Description>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          </Grid.Column>
        </Grid>
        <hr />
        <Container style={{ padding: "1em", textAlign: "right" }}>
          <Button primary onClick={() => setModalFormOpen(false)}>
            <Icon name="close" /> {fragments.common.close}
          </Button>
        </Container>
      </Form>
    </Container>
  );
};
